import Icon from '../components/Icon.vue'

Icon.register({"folder":{"width":1664,"height":1792,"paths":[{"d":"M1664 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/folder.js
// module id = 581
// module chunks = 0